import { render, staticRenderFns } from "./sendMsgRule.vue?vue&type=template&id=b87a8ad6&scoped=true&"
import script from "./sendMsgRule.vue?vue&type=script&lang=js&"
export * from "./sendMsgRule.vue?vue&type=script&lang=js&"
import style0 from "./sendMsgRule.vue?vue&type=style&index=0&id=b87a8ad6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87a8ad6",
  null
  
)

component.options.__file = "sendMsgRule.vue"
export default component.exports